<template>
  <div class="page page-drivers">
    <h1 class="h2">Создание нового документа</h1>
    <div class="row">
      <div class="col-md-6 mb-6">
        <label>Выберите документ</label>
        <select class="form-control" v-model="currentFormComponent">
          <option v-for="({ editComponent, title }, type) of Types" :key="type" :value="editComponent">{{ title }}</option>
        </select>
      </div>
    </div>
    <hr class="mb-4" />
    <component v-if="currentFormComponent" :is="currentFormComponent" @update="handleData" />
    <button class="btn btn-primary" @click="createDocument()">Создать</button>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Types from '@/views/driverDocuments/types'
import DocumentsAPI from '@/api/driver-documents'

export default {
  name: 'CreateDocument',
  props: ['driverId'],
  data () {
    return {
      isCreating: false,
      document: {
        type: '',
        data: '',
        driver_id: this.driverId
      },
      currentFormComponent: null,
      Types
    }
  },
  methods: {
    handleData ({ type, data }) {
      this.document.type = type
      this.document.data = data
    },
    createDocument () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      DocumentsAPI.createItem(this.document)
        .then(document => {
          this.isCreating = false
          this.$router.push(`/drivers/${this.driverId}`)
          return document
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
